import { useEffect, useState } from 'react';
import { BaseSection } from 'components/layouts';
import { useSearchParams } from 'react-router-dom';
import { Row, Col, Divider, Input, Space, Flex } from 'antd';
import { BaseContainer } from 'components/containers';
import { useNavigate } from 'react-router-dom';
import { FillButton } from 'components/elements';
import { TitleLayout } from 'components/layouts';
import { branchTreeData } from 'data/branch/branch-board';

export default function BoardClassCateAdd() {
  const navigate = useNavigate();
  const [serchParams, setSearchParams] = useSearchParams();
  const [selected, setSelected] = useState();

  useEffect(() => {
    console.log(serchParams?.get('no'));

    if (serchParams?.get('no')) {
      console.log(branchTreeData?.filter((it) => it?.key === serchParams?.get('no'))[0]);

      setSelected(branchTreeData?.filter((it) => it?.key === serchParams?.get('no'))[0]);
    } else {
      setSelected({ title: '1차 카테고리' });
    }
  }, []);

  return (
    <BaseSection>
      <BaseContainer height={'100%'}>
        <Row>
          <Col span={24}>
            <TitleLayout>카테고리 추가</TitleLayout>
            <Divider className="divider" />
            <BaseContainer borderColor={'var(--color-gray14)'} backgroundColor={'var(--color-gray15)'} height={'150px'}>
              <Flex vertical gap="middle">
                <Row>
                  <Col span={4} className="search-label">
                    선택된 카테고리
                  </Col>
                  <Col flex="auto" className="search-value">
                    {selected?.title}
                  </Col>
                </Row>
                <Row>
                  <Col span={4} className="search-label">
                    카테고리 추가
                  </Col>
                  <Col flex="auto" className="search-value">
                    <Space>
                      <Input style={{ width: '30rem' }} />
                    </Space>
                  </Col>
                </Row>
              </Flex>
            </BaseContainer>
            <Divider className="divider-small" />
            <Flex justify="flex-end">
              <Space>
                <FillButton
                  label="저장"
                  backgroundColor="var(--color-gray03)"
                  onClick={() => {
                    navigate(-1);
                  }}
                />
              </Space>
            </Flex>
          </Col>
        </Row>
      </BaseContainer>
    </BaseSection>
  );
}
